import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Form, InputGroup } from "react-bootstrap";
import { FaArrowLeft, FaUsers, FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import styles from "./Login.module.css";
import { FiEye } from "react-icons/fi";
import { FiEyeOff } from "react-icons/fi";
import Circle from "../../assets/Frame 155 circle.svg";
import OLogo from "../../assets/OGUN STATE LOGO 1 (1).png";
import House from "../../assets/household.png";
import Gov from "../../assets/government.png";
import Info from "../../assets/info-circle.png";
import { BASE_URL } from "../../Components/API/Api";
import axios from "axios";

const Login = () => {
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [alert, setAlert] = useState({
    show: false,
    type: "", // success | danger
    message: "",
  });

  const handleContinue = () => {
    if (selected === "household") {
      navigate("/household-registration");
    } else if (selected === "government") {
      navigate("/government-registration");
    }
  };


  const handleLogin = async (e) => {
  e?.preventDefault(); // prevents form refresh if used in form
  setLoading(true);
  setErrorMessage("");

  try {
    const response = await axios.post(`${BASE_URL}/login_company`, {
      email,
      password,
    });

    const user = response.data?.data?.user;
    const company = response.data?.data?.company;
    const registration = response.data?.data?.registration_alert;
    const token = response.data?.data?.token;

    if (!user || !token) {
      throw new Error("Invalid response from server");
    }

    // ✅ Save to localStorage
    localStorage.setItem("userName", user.name);
    localStorage.setItem("userEmail", user.email);
    localStorage.setItem("userToken", token);
    localStorage.setItem("companyApproved", company.approval_status);
    localStorage.setItem("hasRegistered", registration.completion_percent);
   
    // 👉 redirect after login
    navigate("/dashboard");

   } catch (error) {
  let errorMsg = "An unexpected error occurred";

  const apiErrors = error?.response?.data?.data;

  if (apiErrors && typeof apiErrors === "object") {
    // get first field error only
    const firstKey = Object.keys(apiErrors)[0];
    if (firstKey && Array.isArray(apiErrors[firstKey])) {
      errorMsg = apiErrors[firstKey][0]; // first message only
    }
  } else if (typeof error?.response?.data?.message === "string") {
    errorMsg = error.response.data.message;
  } else if (error.message) {
    errorMsg = error.message;
  }

  setAlert({
    show: true,
    type: "danger",
    message: errorMsg,
  });
}
     finally {
    setLoading(false);
  }
};

  return (
     <div className={styles.wrapper}>
      {/* <Row className="h-100"> */}

        {/* LEFT SECTION */}
          <div className={styles.leftSection}>
          <div className={styles.leftContent}>

            <div className={styles.logo}>
              <img src={OLogo} className={styles.logoImg} alt="logo" />
              <div className={styles.logoText}>
                <h6>OGUN STATE</h6>
                <p>Social Registry</p>
              </div>
            </div>

            <h2>
              Welcome <span>back</span>
            </h2>

            <p className={styles.desc}>
              Sign in to access the Social Register Portal. Use your registered credentials to continue
            </p>

            <ul className={styles.list}>
              <li>Secure, role-based access control</li>
              <li>Manage household records and verifications</li>
              <li>Generate and export state-wide reports</li>
            </ul>
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div className={styles.rightSection}>
          <div className={styles.rightContent}>

            <div className={styles.back} onClick={() => navigate("/")}>
              <FaArrowLeft style={{marginRight: "10px"}} /> Back to Home
            </div>

            <h4 className={styles.regtext}>Login to your account</h4>
            <p className={styles.sub}>
              Enter your email and password to continue
            </p>

            {/* CARDS */}
            <Form>
 

  
    <Col md={12}>
      <Form.Group>
        <Form.Label className={styles.txtfom}>Email Address</Form.Label>
        <Form.Control
          type="email"
          placeholder="enter email address"
          className={styles.txtfield}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </Form.Group>
    </Col>

    <Col md={12}>
      <Form.Group>
        <Form.Label className={styles.txtfom} style={{marginTop: 24}}>Password</Form.Label>
       <InputGroup>
               <Form.Control
                 type={showPassword ? "text" : "password"}
                 placeholder="Enter password"
                 className={styles.txtfield}
                 value={password}
                 onChange={(e) => setPassword(e.target.value)}
                 
               />
       
               <InputGroup.Text
               className={styles.txtfield}
                 onClick={() => setShowPassword(!showPassword)}
                 style={{
                   cursor: "pointer",
                   background: "#fff",
                   borderLeft: 0,
                 }}
               >
                 {showPassword ? <FiEyeOff /> : <FiEye />}
               </InputGroup.Text>
             </InputGroup>
      </Form.Group>
    </Col>
 
<p className={styles.otpSub} style={{cursor: 'pointer'}} onClick={() => navigate("/forgot_password")}>
      Forgot Password?
    </p>
  

  <Button
    className={styles.signInBtn}
    onClick={handleLogin}
    disabled={loading}
  >
    {loading ? 'Processing your request, please wait...' : "Login"}
  </Button>
</Form>

            {/* NOTE */}
            <div className={styles.note}>
              <div className={styles.noteimg}>
                <img src={Info} alt="Circle" className={styles.infoIcon} />
              </div>
              <p>
                <strong>Note:</strong> Government staff accounts are created by system administrators. Contact your LGA Admin or <span style={{color: '#10B981', cursor: 'pointer'}} onClick={() => window.open('mailto:support@ogunstate.gov.ng', '_blank')}>support@ogunstate.gov.ng</span> if you need access
              </p>
            </div>

            <hr />

             <p className={styles.signup}>
           Don’t have an account? <span style={{fontWeight: 600, color: '#16A34A', cursor: 'pointer'}} >Register Now</span>
          </p>
          
          </div>
        </div>
      {/* </Row> */}
    </div>
  );
};

export default Login;